import { render, staticRenderFns } from "./TypeOfInsulationFormPart.vue?vue&type=template&id=64b01015"
import script from "./TypeOfInsulationFormPart.vue?vue&type=script&lang=js"
export * from "./TypeOfInsulationFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports